<template>

    <div>

        <v-app>
            <v-toolbar flat color="white">
                <v-toolbar-title class="congatec-gray">Protocol</v-toolbar-title>
                <v-spacer></v-spacer>

                <div v-if="protocolEntryReadAll">
                    <v-btn v-if="!showMine" class="text-none" @click="onShowMine()">Show only my entries</v-btn>
                    <v-btn v-else class="text-none" @click="onShowAll()">Show all entries</v-btn>
                </div>
            </v-toolbar>

            <v-divider></v-divider>


            <!-- the following out commented lines are a first draft for the protocol filters  -->


            <!-- <br/>
             <div class="columns protocol-table">
                 <div class="column is-1">Type</div>
                 <div class="column is-2">
                     <v-select :items="items" label="Type"></v-select>
                 </div>
                 <div class="column is-1"></div>
                 <div class="column is-1">Date from</div>
                 <div class="column is-2">
                     <datepicker placeholder="Date from"></datepicker>
                 </div>
                 <div class="column is-3">
 
                     <v-menu ref="menu1"
                             :close-on-content-click="true"
                             v-model="menu1"
                             :nudge-right="40"
                             lazy
                             transition="scale-transition"
                             offset-y
                             full-width
                             max-width="290px"
                             min-width="290px">
                         <v-text-field slot="activator"
                                       v-model="dateFormatted"
                                       label="Date to"
                                       hint="Date to"
                                       persistent-hint
                                       prepend-icon="event"
                                       @blur="date = parseDate(dateFormatted)"></v-text-field>
                         <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                     </v-menu>
 
                 </div>
             </div>
             <div class="columns protocol-table">
                 <div class="column is-1">Object</div>
                 <div class="column is-2">
                     <v-select label="object" :options="objects" dir="auto"></v-select>
                 </div>
                 <div class="column is-1"></div>
                 <div class="column is-1">Description</div>
                 <div class="column is-4">
                     <input class="input is-small" type="date"/>
                 </div>
             </div>
             <div class="columns protocol-table">
                 <div class="column is-1">MAC-Pool</div>
                 <div class="column is-2">
                     <v-select label="macpool" :options="macpools" dir="auto"></v-select>
                 </div>
             </div>
             <div class="columns protocol-table">
                 <div class="column is-1">User</div>
                 <div class="column is-2">
                     <v-select label="username" :options="users" dir="auto"></v-select>
                 </div>
                 <div class="column is-4"></div>
                 <div class="column is-2">
                     <v-btn dark color="rgb(70,70,75)" large @click="onSearchProtocol">
                         <span>Search</span>
                     </v-btn>
                 </div>
             </div>-->


            <!--   -------------------   -->


            <v-card flat>
                <v-card-title>
                    <v-spacer></v-spacer>
                </v-card-title>

                <v-data-table
                        class="datatable"
                        :headers="headers"
                        :items="protocolEntries"
                        :pagination.sync="pagination"
                        :total-items="totalProtocolEntries"
                        :loading="loading"
                        :rows-per-page-items="rowsPerPage">
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.protocolType }}</td>
                        <td class="text-xs-left">{{ props.item.protocolSubType }}</td>
                        <td class="text-xs-left">{{ props.item.timestamp }}</td>
                        <td class="text-xs-left">{{ props.item.executorName }}</td>
                        <td class="text-xs-left">{{ props.item.executorIp }}</td>
                        <td class="text-xs-left">{{ props.item.description }}</td>
                    </template>
                </v-data-table>
            </v-card>
        </v-app>
    </div>


</template>


<script>


    import protocolentryinterface from "../../interfaces/protocolentryinterface";

    export default {
        name: "ProtocolList",

        data: () => ({
            headers: [
                {text: 'Type', value: 'protocolType'},
                {text: 'Subtype', value: 'protocolSubType'},
                {text: 'Timestamp', value: 'timestamp'},
                {text: 'Executor', value: 'executorName'},
                {text: 'Executor IP', value: 'executorIp'},
                {text: 'Description', value: 'description'}
            ],

            pagination: {},

            rowsPerPage: [50, 100, 250, 1000, 5000, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

            loading: true,

            totalProtocolEntries: 0,
            protocolEntries: [],

            showMine: false,

            protocolEntryRead: false,
            protocolEntryReadAll: false
        }),

        created() {
            this.initializeRights();
        },

        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi()
                        .then(data => {
                            this.protocolEntries = data.items;
                            this.totalProtocolEntries = data.total
                        })
                },
                deep: true
            }
        },

        mounted() {
            this.getDataFromApi()
                .then(data => {
                    this.protocolEntries = data.items;
                    this.totalProtocolEntries = data.total
                })
        },

        methods: {
            initialize() {
                protocolentryinterface.getProtocolEntries(entries => {
                    this.protocolEntries = entries;
                })
            },

            async getDataFromApi() {
                this.loading = true;
                return new Promise(async (resolve, reject) => {
                    const {sortBy, descending, page, rowsPerPage} = this.pagination;

                    let items = null;

                    if (this.showMine || !this.protocolEntryReadAll) {
                        await protocolentryinterface.getProtocolEntriesForUser(entries => {
                            items = entries;
                        })
                    } else {
                        await protocolentryinterface.getProtocolEntries(entries => {
                            items = entries;
                        });
                    }

                    const total = items.length;

                    setTimeout(() => {
                        this.loading = false;
                        resolve({
                            items,
                            total
                        })
                    }, 1000)
                })
            },

            async onShowMine() {
                this.showMine = true;

                await this.getDataFromApi().then(data => {
                    this.protocolEntries = data.items;
                    this.totalProtocolEntries = data.total
                });
            },

            async onShowAll() {
                this.showMine = false;

                await this.getDataFromApi().then(data => {
                    this.protocolEntries = data.items;
                    this.totalProtocolEntries = data.total
                });
            },

            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "ProtocolEntryRead") {
                        this.protocolEntryRead = true;
                    }

                    if (right.right === "ProtocolEntryReadAll") {
                        this.protocolEntryReadAll = true;
                    }
                });
            },
        }
    };


</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/protocol/ProtocolList.vue